const topics = [
  { name: '科幻大片', count: '3.2万讨论' },
  { name: '动作冒险', count: '2.8万讨论' },
  { name: '喜剧推荐', count: '2.5万讨论' },
  { name: '悬疑烧脑', count: '2.1万讨论' },
  { name: '动画电影', count: '1.9万讨论' },
  { name: '爱情文艺', count: '1.7万讨论' },
  { name: '恐怖惊悚', count: '1.5万讨论' },
  { name: '纪录片', count: '1.2万讨论' },
  { name: '经典重温', count: '1.1万讨论' },
  { name: '新片速递', count: '2.9万讨论' },
  { name: '冷门佳片', count: '9800讨论' },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            六六影院影迷社区最火热的话题标签，加入讨论发现更多好片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((item) => (
            <div
              key={item.name}
              className="group flex items-center gap-3 bg-background-50 rounded-full px-5 py-3 cursor-pointer transition-all duration-300 hover:-translate-y-0.5 hover:bg-primary-50"
            >
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                #{item.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200/70 rounded-full px-2.5 py-0.5 whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}